import React, { useRef, useState } from 'react';
import emailjs from 'emailjs-com';
import './ContactForm.css'; 

const ContactForm = () => {
  const form = useRef();
  
  const [message, setMessage] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);

  const SERVICE_ID = "service_co5ymdw"; 
  const TEMPLATE_ID = "template_pn9qrct";
  const USER_ID = "9uDyOT0UkvQz7nXLa"; 

  const sendEmail = (e) => {
    e.preventDefault(); 

    setMessage('Sending...');
    setIsSuccess(false);

    emailjs.sendForm(SERVICE_ID, TEMPLATE_ID, form.current, USER_ID)
      .then((result) => {
        console.log('Email successfully sent!', result.text);
        setMessage('Thank you! Your message has been sent successfully.');
        setIsSuccess(true);
        form.current.reset(); 
      }, (error) => {
        console.error('Email sending failed:', error.text);
        setMessage('Failed to send the message. Please try again later.');
        setIsSuccess(false);
      });
  };

  return (
    <div className="contact-form-container">
      <h2>Get in Touch</h2>
      
      <form ref={form} onSubmit={sendEmail} className="contact-form">
        
        <div className="form-group">
          <label htmlFor="user_name">Name</label>
          <input type="text" name="user_name" id="user_name" required />
        </div>
        
        <div className="form-group">
          <label htmlFor="user_email">Email</label>
          <input type="email" name="user_email" id="user_email" required />
        </div>
        
        <div className="form-group">
          <label htmlFor="message">Message</label>
          <textarea name="message" id="message" rows="5" required />
        </div>
        
        <button type="submit" className="submit-button">Send Message</button>
      </form>

      
      {message && (
        <p className={`form-feedback ${isSuccess ? 'success' : 'error'}`}>
          {message}
        </p>
      )}

    </div>
  );
};

export default ContactForm;